import * as React from 'react';
import { CircularProgress, TextField } from '@mui/material';
import { Close } from '@mui/icons-material';

interface Props {
  value: string;
  setValue: (value: string) => void;
  fetching?: boolean;
  placeholder?: string;
}

export const FilterInput: React.FC<Props> = (props) => {
  const { value, setValue, fetching, placeholder } = props;

  return (
    <div className="px-3 py-2">
      <TextField
        autoFocus
        variant="outlined"
        size="small"
        fullWidth
        placeholder={placeholder}
        classes={{
          root: 'focus:!filter-none focus:!border-none',
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
        value={value}
        InputProps={{
          classes: { root: 'pr-0' },
          endAdornment: (
            <div className="flex">
              {fetching && <CircularProgress color="primary" size={12} />}
              {value && (
                <Close
                  className="cursor-pointer"
                  style={{ fontSize: 14 }}
                  onClick={() => setValue('')}
                />
              )}
            </div>
          ),
        }}
      />
    </div>
  );
};
FilterInput.displayName = 'Shipments.Components.ReferenceFilter.FilterInput';
